import { render, staticRenderFns } from "./AssistanceServiceForm.vue?vue&type=template&id=c2dcdf22&scoped=true"
import script from "./AssistanceServiceForm.vue?vue&type=script&lang=ts"
export * from "./AssistanceServiceForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dcdf22",
  null
  
)

export default component.exports